import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p1304Api, QueryParams, CompanyRow, CodeMapRow, GroupCount } from '../../../services/p1304Api';

export function useP1304Query() {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState<CompanyRow[]>([]);
  const [codeMap, setCodeMap] = useState<CodeMapRow[]>([]);
  const [groups, setGroups] = useState<GroupCount[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await p1304Api.query(params);
      const hasCompanies = resp.companies && resp.companies.length > 0;
      const hasCodeMap = resp.code_map && resp.code_map.length > 0;
      if (hasCompanies || hasCodeMap) {
        setCompanies(resp.companies || []);
        setCodeMap(resp.code_map || []);
        setGroups(resp.groups || []);
        setNoData(false);
      } else {
        setCompanies([]);
        setCodeMap([]);
        setGroups([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setCompanies([]);
    setCodeMap([]);
    setGroups([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, companies, codeMap, groups, queried, noData, runQuery, reset };
}
